import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = (props: SvgProps) => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" testID="closeIcon" {...props}>
        <Path
            d="M4.5 4.5L15.5 15.5M4.5 15.5L15.5 4.5"
            stroke={props.color || ds.colorValue.icon.primary}
            strokeWidth={1.5}
            strokeLinecap="round"
        />
    </Svg>
);
export { SvgComponent as CloseSmallIcon };
